import React from "react";
import { Box, Typography, Chip, Stack } from "@mui/material";
import { UploadedFile } from "../../../components/FileUploadSection";
import { formatText } from "../../../utils/utils";
import { iconProps } from "../../../utils/styles";
import { Description as FileIcon } from "@mui/icons-material";
interface DocumentStackDisplayProps {
  documents?: UploadedFile[];
}

const DocumentStackDisplay: React.FC<DocumentStackDisplayProps> = ({
  documents = [],
}) => {
  if (!documents || documents.length === 0) {
    return (
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ fontSize: "0.7rem" }}
      >
        No Documents
      </Typography>
    );
  }

  return (
    <Stack
      direction="column"
      spacing={1}
      sx={{
        flexWrap: "wrap",
      }}
    >
      {documents.map((document, index) => {
        return (
          <Box key={index} sx={{ display: "flex", alignItems: "center" }}>
            <Chip
              label={
                <Stack direction="row" spacing={0.5} alignItems="center">
                  <FileIcon color="primary" {...iconProps} />{" "}
                  <Typography variant="caption" sx={{ fontSize: "0.65rem" }}>
                    {document.fileName.length > 20
                      ? `${document.fileName.slice(0, 20)}...`
                      : document.fileName}
                  </Typography>
                </Stack>
              }
              color={"default"}
              variant="outlined"
              size="small"
              sx={{
                fontSize: "0.65rem",
                height: "20px",
                "& .MuiChip-label": {
                  px: 0.5,
                },
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: "action.hover",
                },
              }}
              onClick={() => {
                window.open(document.presignedUrl, "_blank");
              }}
            />
          </Box>
        );
      })}
    </Stack>
  );
};

export default DocumentStackDisplay;
